import React from 'react';

import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import type { QueryKey } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

const CACHE_TIME = 1000 * 60 * 60 * 24; // 24 hours

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: CACHE_TIME,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({ storage: window.localStorage });

const persistQueryOption: React.ComponentProps<typeof PersistQueryClientProvider>['persistOptions'] = {
  persister: localStoragePersister,
  maxAge: CACHE_TIME,
  hydrateOptions: {
    defaultOptions: {
      queries: { queryKey: ['AIMS_CATEGORY', 'NECK-SHOULDER', 'AIMS_FABRIC', 'COLOR'] },
    },
  },
  dehydrateOptions: {
    shouldDehydrateQuery: ({ queryKey }: { queryKey: QueryKey }) => {
      /**
       * NOTE: 해당 key를 가진 query만 캐시합니다.
       */
      return (
        queryKey.includes('AIMS_CATEGORY') ||
        queryKey.includes('NECK-SHOULDER') ||
        queryKey.includes('AIMS_FABRIC') ||
        queryKey.includes('COLOR')
      );
    },
  },
};

/**
 * 유저 수준 쿼리 클라이언트.
 */
export const UserPersistQueryClientProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistQueryOption}>
      {children}
    </PersistQueryClientProvider>
  );
};
